// quizData.ts

export type QuestionType = 'choice' | 'multiple_choice' | 'listening' | 'essay';

export interface AdminQuestionItem {
    id: number;
    questionNumber: number;
    category: string;
    type: string;
    questionText: string;
    optionA: string;
    optionB: string;
    optionC: string;
    optionD: string;
    correctAnswer: string;
    referenceAnswer: string;
    audioText?: string; 
}

export interface Question {
    id: number;
    questionNumber?: number;
    type: QuestionType;
    question: string;
    options?: string[];
    correct?: number; 
    keyAnswer?: string; 
    explanation: string;
    audioText?: string; 
}

export interface UserData {
    id: string | number;
    name: string; 
    email?: string;
}

export const defaultQuestions: Question[] = [
    { 
        id: 1, 
        type: 'multiple_choice', 
        question: "Apa warna bendera Indonesia?", 
        options: ["Merah Putih", "Biru", "Kuning", "Hijau"], 
        correct: 0, 
        explanation: "Bendera Indonesia adalah Merah Putih." 
    }
];

// Alias agar import di Result.tsx tidak error
export const questions = defaultQuestions;